/**
 * @generated SignedSource<<5e3d4457e669342349f130d067561a0d>>
 * @relayHash 5aedf8a1be396fbb2394cd2530ac84b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b225cf1f22cef73f9d62af2fb99e4c0e236a0d137baa64865081eed8f7c8a0b7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useCreateAgentMenuItemStudioPermissionsQuery$variables = {
  cloudId: string;
};
export type useCreateAgentMenuItemStudioPermissionsQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly userPermissions?: {
      readonly isAbleToCreateAgents: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useCreateAgentMenuItemStudioPermissionsQuery = {
  response: useCreateAgentMenuItemStudioPermissionsQuery$data;
  variables: useCreateAgentMenuItemStudioPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianStudioUserProductPermissions",
      "kind": "LinkedField",
      "name": "userPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAbleToCreateAgents"
        }
      ]
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateAgentMenuItemStudioPermissionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateAgentMenuItemStudioPermissionsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5aedf8a1be396fbb2394cd2530ac84b3",
    "id": "b225cf1f22cef73f9d62af2fb99e4c0e236a0d137baa64865081eed8f7c8a0b7",
    "metadata": {},
    "name": "useCreateAgentMenuItemStudioPermissionsQuery",
    "operationKind": "query",
    "text": "query useCreateAgentMenuItemStudioPermissionsQuery($cloudId:ID!){atlassianStudio_userSiteContext(cloudId:$cloudId){__typename,...on AtlassianStudioUserSiteContextOutput{userPermissions{isAbleToCreateAgents}}}}"
  }
};
})();

(node as any).hash = "9d7d53325d94d96d60598c496e98f030";

export default node;
